import { render, staticRenderFns } from "./changeProfileModal.vue?vue&type=template&id=491e1ba2&"
import script from "./changeProfileModal.vue?vue&type=script&lang=js&"
export * from "./changeProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./changeProfileModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports